export var HARD_STOP_REASON;
(function (HARD_STOP_REASON) {
    HARD_STOP_REASON["REGISTRATION_DOWN"] = "registration-down";
    HARD_STOP_REASON["SESSION_SUPERSEDED"] = "session-superseded";
})(HARD_STOP_REASON || (HARD_STOP_REASON = {}));
